import { range } from 'lodash';

export const QTY_OPTIONS = range(1, 21).map((qty) => {
  return { value: qty, label: qty };
});
